import type { EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate } from '@/common/graphql';

import { DateWithCount } from '../DateWithCount';

export const DetailDescriptionEmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate, 'lastEndDate' | 'resignationDate'>;
}) => (
  <>
    <div>
      <DateWithCount prefix="Last job history end date" date={reason.lastEndDate} />
    </div>
    <div>
      <DateWithCount prefix="Employment end date" date={reason.resignationDate} />
    </div>
  </>
);
